exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "i.fa-edit[data-v-4eec2cd2]{margin-top:7px!important}", ""]);

// exports
